import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ChatwootService {

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  init() {
    if (!isPlatformBrowser(this.platformId)) return;

    if ((window as any).chatwootSDK) return;

    const BASE_URL = environment.chatwoot.baseUrl;
    const WS_TOKEN = environment.chatwoot.websiteToken;

    const script = document.createElement('script');
    script.src = `${BASE_URL}/packs/js/sdk.js`;
    script.defer = true;
    script.async = true;

    script.onload = () => {
      (window as any).chatwootSDK.run({
        websiteToken: WS_TOKEN,
        baseUrl: BASE_URL
      });
    };

    document.body.appendChild(script);
  }
}